import { format } from "date-fns";

/**
 * Safely extract a string value from iCalendar fields that may be
 * returned as `{ val: string, params: object }` instead of a plain string.
 *
 * The schema unwraps this shape, but the payload reaches the invite card and the invite line
 * unparsed as well, so both do it again here rather than rendering "[object Object]".
 */
export const safeString = (value: unknown): string => {
	if (typeof value === "string") {
		return value;
	}

	if (typeof value === "object" && value !== null && "val" in value) {
		return String((value as { val: unknown }).val);
	}

	return value != null ? String(value) : "";
};

/** A VEVENT timestamp as the thread shows it; the raw value when it is not a date at all. */
export const formatEventDate = (
	dateStr: unknown,
	pattern = "EEE, MMM d, yyyy 'at' h:mm a"
): string => {
	const safe = safeString(dateStr);

	if (!safe) {
		return "Unknown date";
	}

	try {
		const date = new Date(safe);

		if (isNaN(date.getTime())) {
			return safe;
		}

		return format(date, pattern);
	} catch {
		return safe;
	}
};
